var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full py-16 px-4"},[_c('Swipetopay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }